import { GetterTree } from 'vuex'
import { RootState } from '../types'
import State, { IMaterialConfiguration, ISapConfigureMaterialRequest } from './types'
import { Model } from '../model-viewer/types'

export const getters: GetterTree<State, RootState> = {
  configurableMaterials(state): Model[] {
    const { materials } = state
    return materials || []
  },
  request(state): ISapConfigureMaterialRequest {
    const { request } = state
    return request
  },
  configuration(state): IMaterialConfiguration {
    const { configuration } = state
    return configuration
  },
  configurationLoaded(state): number {
    const { configurationLoaded } = state
    return configurationLoaded
  },
}
